import React, { useEffect, useState } from "react";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import WeightManageChart from "./WeightManageChart";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { formatDate, getPreviousDate, today } from "../../../Helper/Helper";
import { SendPostRequest } from "../../../http";

function WeightManagment() {
  const patientData = useSelector((store) => store.patient.patientLogin);
  const [showModal, setShowModal] = useState(false);
  const [getData, setGetData] = useState({});
  const [loadingGraph, setLoadingGraph] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previousDate, setPreviousDate] = useState(getPreviousDate(7));
  const [addData, setAddData] = useState({
    in_kg: null,
    record_date: null,
    notes: "",
  });
  const today = new Date();
  // const getPreviousDate = (days) => {
  //   const today = new Date();
  //   const previousDate = new Date();
  //   return previousDate.setDate(today.getDate() - days);
  // };

  const timeStamp = [
    { value: "1-week", label: "1 Week" },
    { value: "2-week", label: "2 Weeks" },
    { value: "3-week", label: "3 Weeks" },
    { value: "4-week", label: "4 Weeks" },
  ];
  const [selectedTimeStamp, setSelectedTimeStamp] = useState(timeStamp[0]);

  const handleModalOpen = () => {
    setShowModal(true);
  };
  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleOnChange = (e) => {
    const { value, name } = e.target;
    setAddData((prv) => ({ ...prv, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      // logged_id: "858",
      logged_id: patientData?.logged_id,
      form_data: addData,
    };
    setLoading(true);
    try {
      const response = await SendPostRequest("healthcare/weight/add", data);
      if (response?.status === "success") {
        // toast.success(response?.message);
        handleModalClose();
        fetchData();
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedTimeStamp]);

  const fetchData = async () => {
    setLoadingGraph(true);
    try {
      const response = await SendPostRequest("healthcare/weight/graph", {
        // logged_id: "858",
        logged_id: patientData?.logged_id,
        timespan: selectedTimeStamp?.value || "",
      });
      if (response?.status === "success") {
        // toast.success(response?.message);
        setGetData(response?.data);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoadingGraph(false);
      setPreviousDate(
        getPreviousDate(7 * +selectedTimeStamp?.value?.slice(0, 1))
      );
    }
  };

  return (
    <>
      <div className="weight_management_header">
        <h4>Weight Management </h4>
        <p>
          ({formatDate(previousDate)}) to ({formatDate(today)})
        </p>
        <div className="weight_management_right_content">
          <button
            className="weight_management_modal_btn"
            onClick={handleModalOpen}
          >
            +
          </button>

          <Select
            name="title"
            className="weight_management_dropdown"
            // placeholder="Select"
            defaultValue={selectedTimeStamp}
            options={timeStamp}
            onChange={(e) => {
              setSelectedTimeStamp(e);
            }}
          />
        </div>
      </div>

      <div className="pt-5">
        <WeightManageChart data={getData} loading={loadingGraph} />
      </div>

      {/* 
      <div className=" graph_image pt-5">
        <img src="/assets/img/graph_img.jpeg" alt="Graph" />
      </div> */}

      <Modal
        className="modal-wrapper"
        show={showModal}
        onHide={handleModalClose}
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title className="weight_management_modal-title">
              Weight Management
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <label className="cs_input_label cs_heading_color">
                  Weight In Kg
                </label>
                <input
                  required
                  type="number"
                  className="weight_management_modal_input"
                  placeholder="Enter Weight In Kg"
                  name="in_kg"
                  onChange={handleOnChange}
                />
                <div className="cs_height_42 cs_height_xl_25"></div>
              </div>
              <div className="col-lg-6">
                <label className="cs_input_label cs_heading_color">Date</label>
                <input
                  required
                  type="date"
                  className="weight_management_modal_input"
                  placeholder="Select Date"
                  onChange={handleOnChange}
                  name="record_date"
                  max={today}
                />
                <div className="cs_height_42 cs_height_xl_25"></div>
              </div>
              <div className="col-lg-12">
                <label className="cs_input_label cs_heading_color">Note</label>
                <input
                  type="text"
                  className="weight_management_modal_input"
                  placeholder="Enter Your Note"
                  onChange={handleOnChange}
                  name="notes"
                />
                <div className="cs_height_42 cs_height_xl_25"></div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="weight_management_submit-button"
              variant="btn btn-default"
              type="submit"
              disabled={loading}
            >
              {loading ? "Submiting..." : "Submit"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

export default WeightManagment;
